export default {
  sm: `
  Reliable Infrastructure
  Operating the Nation’s
  Largest IT Service    
  `,
  lg: `
  Reliable Infrastructure Operating the 
  Nation’s Largest IT Service    
  `,
  xxl: `
  Reliable Infrastructure
  Operating the Nation’s
  Largest IT Service    
  `,
};
